// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".test-status-legend[data-v-72be63ca]{padding:2px 8px;display:flex;align-items:center;gap:12px;flex-wrap:wrap;font-size:14px;color:#666;background-color:#eee;border-radius:4px}.legend-item[data-v-72be63ca]{display:flex;align-items:center;gap:4px}.legend-color[data-v-72be63ca]{display:inline-block;width:15px;height:15px;border-radius:2px;opacity:.8}", ""]);
// Exports
module.exports = exports;
